module.exports = __webpack_public_path__ + "img/3.691dc8d1.jpg";